
import SEO from '@/services/seo'
import Provider from '@/services/provider'
import gtm from '~/mixins/gtm'
import { head, setAlternate } from '@/utils/head'

export default {
  mixins: [gtm],

  nuxtI18n: {
    parsePages: false,
    locales: ['pt-br', 'en', 'es'],
  },

  data() {
    return {
      gtmSubsection: 'Positions',
      gtmSubsection2: 'Find your job',
      isLoading: true,
      locale: this.$i18n.locale,
      lang: this.$i18n.locale.slice(0, 2),
      gtmData: this.$t('pages.home.Positions').gtm,
    }
  },

  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    const url = `${process.env.BASE_URL}${this.$route.path}`
    const lang = this.lang
    const title = this.$t('seo.positions.title')
    const description = this.$t('seo.positions.description')
    const payload = {
      routeName: this.$route.name,
      param: false,
      data: { areas: false, positions: false },
    }

    return head({
      url,
      lang,
      title,
      description,
      canonical: url,
      htmlAttrs: { ...i18nHead.htmlAttrs },
      link: setAlternate(payload),
      breadcrumbs: SEO.schema.breadcrumbs.getSchemaObj(this.breadcrumbs),
    })
  },
  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },
  mounted() {
    this.isLoading = false
  },
}
